import styled, { createGlobalStyle } from "styled-components";
import BgNovoEvento from "./Images/BgNovoEvento.png";
import ImgAvatarHome from "./Images/BgAvatar.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";
import ImgCurvaTopDir from "./Images/curva_top_dir.png";
import ImgCurvaTopEsq from "./Images/curva_top_esq.png";
import BgCaminhoPesquisas from "./Images/BgGranularClassico.jpg";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
  }
  
  .Cal__Day__enabled {
	  pointer-events: none;
  }

  .Cal__Day__selected {
	  pointer-events: all;
  }
`;

export const Clear = styled.div`
  clear: both;
`;

export const Button = styled.button`
  color: #f00;
  background-color: #00f;
  font-size: 20px;
  margin: 5px;
  border: none;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: #00f;
    background-color: #f00;
  }
`;

export const Titulo = styled.h1`
  color: #f00;
  font-size: 20px;
  margin: 5px;
  span {
    color: #00f;
    font-size: 10px;
  }
`;

export const Texto = styled.div`
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontsize + "px"};
`;

export const ImgTest = styled.img`
  width: 100%;
  display: block;
  margin: 0 auto;
  max-width: ${(props) => props.ImgProps.MaxWidth + "px"};
  background-size: cover;
`;

export const BgDiv = styled.div`
  background-image: url(${(props) => props.UrlImg});
  background-position: center center;
  width: 640px;
  height: 360px;
  margin: 0 auto;
  background-size: cover;
`;

export const ImgTest2 = styled(ImgTest)`
  max-width: 100px;
  background-color: #000000;
`;

export const BackgroundImg = styled.div`
  /* display: grid; */
  text-align: center;
  background-image: url(${(props) => props.Background});
  background-position: top center;
  background-repeat: repeat;
  background-color: ${(props) => props.bgcolor};
  min-height: 100vh;
  @media (max-width: 800px) {
    background-image: url(${(props) => props.BackgroundMob});
  }
`;

export const Coluna = styled.div`
  /* text-align: center; */
  width: calc(100% - 100px);
  max-width: 1650px;
  margin: 0 auto;
  @media (max-width: 800px) {
    width: calc(100% - 40px);
  }
`;

export const ColunaAvatar = styled.div`
  /* text-align: center; */
  width: calc(100% - 100px);
  max-width: 450px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 800px) {
    width: calc(100% - 40px);
  }
`;

export const LogoMinhaBunge = styled.img`
  width: 100%;
  display: inline-block;
  margin: 30px auto 30px auto;
  max-width: ${(props) => props.MaxWidth};
`;

export const FormLogin = styled.form`
  display: block;
  text-align: center;
  margin-bottom: 100px;
`;

export const FormCadastro = styled.form`
  display: block;
  text-align: center;
  margin: 0 auto;
  max-width: 550px;
  margin-bottom: 100px;
`;

export const FormSenha = styled.form`
  display: block;
  text-align: center;
  margin: 0 auto;
  max-width: 550px;
`;

export const CampoForm = styled.div`
  max-width: 385px;
  margin: 0 auto;
  margin-bottom: 10px;
  text-align: left;
  position: relative;
  input {
    font-family: "Roboto", sans-serif;
    font-size: 20px;

    background-color: #043c54;
    color: #ffffff;
    border: none;
    outline: none;

    padding: 15px 15px;
    padding-left: 50px;
    width: calc(100% - 77px);
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
    border-radius: 8px;
    border: 1px solid #043c54;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
    text-align: center;
  }
`;

export const CheckBox = styled.div`
  margin: 10px 0px 20px 0px;
  input {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    cursor: pointer;
  }
  div {
    display: inline-block;
    vertical-align: middle;
  }
`;

export const DoisCampos = styled.div`
  display: flex;
  max-width: 800px;
  margin: 0 auto;
  div {
    &:first-child {
      margin-right: 5px;
    }
    &:last-child {
      margin-left: 5px;
    }
  }
  @media (max-width: 650px) {
    display: block;
    div {
      &:first-child {
        margin-right: auto;
      }
      &:last-child {
        margin-left: auto;
      }
    }
  }
`;

export const CampoFormCadastro = styled.div`
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  text-align: left;
  margin-bottom: 10px;
  position: relative;

  input,
  select,
  aside,
  textarea {
    font-family: "Roboto", sans-serif;
    font-size: 20px;

    background-color: #043c54;
    color: #ffffff;
    border: none;
    outline: none;

    padding: 15px 15px;
    width: calc(100% - 32px);
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
    border-radius: 8px;
    border: 1px solid #043c54;
    line-height: normal;
  }
  select {
    border: none;
  }
  textarea {
    height: 110px;
    resize: none;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
    text-align: center;
  }
  .RadioDesafio {
    padding: 5px 15px;
  }
`;

export const ListaFiltro = styled(CampoFormCadastro)`
  width: 100%;
  max-width: 385px;
  margin: 0;
  position: relative;
  input,
  select,
  aside,
  textarea {
    font-family: "Roboto", sans-serif;
    font-size: 20px;

    background-color: #043c54;
    color: #ffffff;
    border: none;
    outline: none;

    padding: 15px 15px;
    width: calc(100% - 32px);
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
    border-radius: 8px;
    border: 1px solid #043c54;
    line-height: normal;
  }
  select {
    border: none;
  }
  textarea {
    height: 110px;
    resize: none;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    text-align: center;
  }
`;

export const ListaFiltroTecnicos = styled(ListaFiltro)`
  width: 100%;
  max-width: 476px;
  margin: 10px auto 0 auto;
  position: relative;
  input,
  select,
  aside,
  textarea {
    font-family: "Roboto", sans-serif;
    font-size: 20px;

    background-color: #043c54;
    color: #ffffff;
    border: none;
    outline: none;

    padding: 15px 15px;
    width: calc(100% - 32px);
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
    border-radius: 8px;
    border: 1px solid #043c54;
    line-height: normal;
  }
  select {
    border: none;
  }
  textarea {
    height: 110px;
    resize: none;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    text-align: center;
  }
`;

export const BotaoEntrar = styled.button`
  color: #043c54;
  font-size: 23px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 100px;
  padding: 10px 45px;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background-color: #ffffff;
  letter-spacing: 3px;
  &:hover {
    background-color: #3fb6fa;
    color: #ffffff;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
  }
`;

export const IcoForm = styled.img`
  width: 100%;
  display: block;
  max-width: 30px;
  position: absolute;
  z-index: 2;
  top: 13px;
  left: 16px;
`;

export const BtEsqueciSenha = styled.a`
  display: inline-block;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  color: #ffffff;
  cursor: pointer;
  margin: 20px auto 10px auto;
  padding: 3px 10px;
  border-radius: 4px;
  user-select: none;
  &:hover {
    background-color: #3fb6fa;
    color: #ffffff;
  }
`;

export const BgAvatarHome = styled.div`
  display: block;
  background-image: url(${ImgAvatarHome});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  width: 130px;
  height: 130px;
  position: relative;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  svg {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: 0px;
  }
  &:hover {
    opacity: 0.5;
  }
`;

export const FooterLogin = styled.div`
  /* position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  bottom: 20px; */
  margin-top: 70px;
  padding-bottom: 20px;
`;

export const BotaoCadastro = styled.button`
  color: #ffffff;
  font-size: 20px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 100px;
  padding: 10px 30px;
  margin-bottom: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background-color: #043c54;
  letter-spacing: 2px;
  &:hover {
    background-color: #3fb6fa;
    color: #ffffff;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
  }
`;

export const LogoBunge = styled.img`
  max-width: 130px;
`;

export const TopNavegacao = styled.div`
  background-color: #043c54;
  text-align: left;
  padding: 10px 0px;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    background-image: url(${ImgCurvaTopDir});
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 25px;
    height: 54px;
    bottom: -54px;
    left: 0;
  }
  &:after {
    content: "";
    position: absolute;
    background-image: url(${ImgCurvaTopEsq});
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 25px;
    height: 54px;
    bottom: -54px;
    right: 0;
  }
`;

export const TitItem = styled.div`
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  color: #ffffff;
  font-size: 20px;
`;

export const BtSetaVoltar = styled.div`
  margin-top: -1px;
  position: absolute;
  text-align: center;
  background-image: url(${ImgBtSetaVoltar});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 25px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
`;

export const TopoHome = styled.div`
  width: 100%;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 1;
`;
export const MapaHome = styled.div`
  background-color: #e7e097;
  /* width: 100%;
    height: 100%; */
  width: 1980px;
  height: 2390px;
  /* position: absolute; */
  /* top: -10%; */
  /* left: 0; */
  /* right: 0; */
  z-index: 0;
  background-image: url(${(props) => props.src});

  /* top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */

  /* background-size: contain;
    background-position: center; */
  background-repeat: no-repeat;
  /* max-width: 1000px; */
  margin: 0 auto;
  cursor: move;
`;

export const BtMapa = styled.img`
  position: absolute;
  z-index: 2;
  top: ${(props) => props.top + "%"};
  left: ${(props) => props.left + "%"};
  width: 210px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.7;
  }
`;

export const DivMenuPrinc = styled.div`
  position: fixed;
  bottom: 15px;
  z-index: 3;
  /* background-color: black; */
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  padding: 5px 10px;
  display: flex;
  justify-content: center;
`;

export const BgMenuPrinc = styled.div`
  position: fixed;
  bottom: -5px;
  height: 35%;
  z-index: 3;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  padding: 5px 10px;
  width: 95%;
  background-color: #d0d1d3;
  -webkit-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;

export const BtsMenuPrinc = styled.div`
  position: relative;
  z-index: 10;
  background-size: contain;
  background-position: bottom center;
  background-repeat: no-repeat;
  width: 70px;
  height: 70px;
  margin: 0 5px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
`;

export const BtMenuPesquisas = styled(BtsMenuPrinc)`
  background-image: url(${(props) => props.Bg});
  &:hover {
    background-image: url(${(props) => props.BgAtivo});
  }
`;

export const BtMenuNoticias = styled(BtsMenuPrinc)`
  background-image: url(${(props) => props.Bg});
  &:hover {
    background-image: url(${(props) => props.BgAtivo});
  }
`;

export const BtMenuRelatorio = styled(BtsMenuPrinc)`
  background-image: url(${(props) => props.Bg});
  &:hover {
    background-image: url(${(props) => props.BgAtivo});
  }
`;

export const BtMenuConteudos = styled(BtsMenuPrinc)`
  background-image: url(${(props) => props.Bg});
  &:hover {
    background-image: url(${(props) => props.BgAtivo});
  }
`;

export const BtMenuRegras = styled(BtsMenuPrinc)`
  background-image: url(${(props) => props.Bg});
  &:hover {
    background-image: url(${(props) => props.BgAtivo});
  }
`;

export const BtsRankingMoedas = styled.div`
  text-align: left;
  font-family: "Milky Nice Clean";
  font-size: 15px;
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #e4e5e4;
    color: #043c54;
    margin: 5px 0;
    padding: 5px 0px 5px 0px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    -webkit-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.15);
    span {
      display: flex;
      align-items: center;
    }
    img {
      max-width: 22px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
`;

export const BtNovoEvento = styled.div`
  background-image: url(${BgNovoEvento});
  background-size: contain;
  width: 86px;
  height: 100px;
  margin-left: 30px;
  user-select: none;
  cursor: pointer;
  font-family: "Milky Nice Clean";
  color: #043c54;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  div {
    padding-top: 40px;
    font-size: 14px;
    line-height: 15px;
  }
  &:hover {
    color: #3fb6fa;
  }
`;

export const ModalEvento = styled.div`
  color: #043c54;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  padding: 20px;
  width: calc(80% - 40px);
  max-width: 450px;
  height: 50%;
  max-height: 450px;
  border-radius: 8px;
  -webkit-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  .TituloEvento {
    font-family: "Milky Nice Clean";
    color: #043c54;
    font-size: 23px;
    margin-bottom: 15px;
    text-align: left;
  }
  .TextoEvento {
    height: calc(100% - 50px);
    padding-right: 15px;
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .ListaClientes {
    height: calc(100% - 90px);
    padding-right: 15px;
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .BtFecharModal {
    float: left;
    color: #ffffff !important;
    font-family: "Roboto";
    font-weight: 600;
    background-color: #043c54;
    padding: 5px 10px;
    border-radius: 6px;
    margin-top: 20px;
    cursor: pointer;
    &:hover {
      background-color: #3fb6fa;
    }
  }
`;

export const TextoRegras = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto 25px auto;
  font-family: "Roboto";
  color: #ffffff;
  text-align: left;
  .TituloRegras {
    font-family: "Roboto";
    font-weight: 900;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .TextoRegras {
    font-family: "Roboto";
    font-size: 16px;
  }
`;

export const TitRegrasPontuacao = styled.div`
  font-family: "Milky Nice Clean";
  color: #ffffff;
  font-size: 30px;
  margin-bottom: 20px;
`;

export const ColunaRegras = styled.div`
  max-height: calc(100vh - 100px);
  overflow: auto;
  .AreaColunaRegras {
    width: calc(71% - 100px);
    max-width: 1160px;
    margin: 0 auto;
    position: relative;
    @media (max-width: 800px) {
      width: calc(100% - 40px);
    }
  }
`;

export const ColunaRegulamento = styled(ColunaRegras)`
  max-height: calc(100vh);
  overflow: auto;
  .AreaColunaRegras {
    width: calc(100%);
    @media (max-width: 800px) {
      width: calc(100%);
    }
  }
`;

export const ColunaPerfilAvatar = styled.div`
  max-height: calc(100vh - 100px);
  overflow: auto;
  .AreaColunaPerfilAvatar {
    width: calc(100% - 100px);
    max-width: 550px;
    margin: 0 auto;
    position: relative;
    @media (max-width: 800px) {
      width: calc(100% - 40px);
    }
  }
`;

export const TitNoticias = styled.div`
  margin: 20px auto 15px auto;
  font-family: "Roboto";
  font-weight: 900;
  color: #043c54;
  text-align: center;
  font-size: 25px;
  text-transform: uppercase;
`;

export const DivItemNoticia = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;
  max-width: 45%;
  text-align: left;
  margin: 0px 10px 30px 10px;
  cursor: pointer;
  .TitNoticia {
    color: #043c54;
    font-family: "Roboto";
    font-weight: 900;
    font-size: 23px;
    margin-bottom: 5px;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  .DesNoticia {
    color: #000000;
  }
  &:hover {
    .TitNoticia {
      color: #3fb6fc;
    }
  }
  @media (max-width: 500px) {
    max-width: 100%;
  }
`;

export const BgImgNoticia = styled.div`
  background-image: url(${(props) => props.BgImg});
  background-size: cover;
  background-position: center center;
  background-color: #000000;
  border-radius: 8px;
  width: 100%;
  height: 200px;
  margin-bottom: 15px;
`;

export const ImgNoticia = styled.img`
  background-color: #000000;
  border-radius: 8px;
  width: 100%;
  max-width: 550px;
  /* height: 200px; */
  margin-bottom: 15px;
`;

export const DivBtsNoticiaNovidades = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const BtNoticiaNovidades = styled.div`
  font-family: "Roboto";
  font-weight: 600;
  text-align: center;
  font-size: 14px;
  background-color: #043c54;
  color: #ffffff;
  padding: 8px 10px;
  margin: 0px 10px;
  border-radius: 6px;
  width: 160px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #3fb6fc;
  }
`;

export const BtNoticiaNovidadesSelecionado = styled.div`
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  background-color: #3fb6fc;
  color: #ffffff;
  padding: 8px 10px;
  margin: 0px 10px;
  border-radius: 6px;
  width: 160px;
  cursor: default;
`;

export const TituloNoticiaDescricao = styled.div`
  width: 100%;
  text-align: center;
  margin: 0px auto 10px auto;
  color: #043c54;
  font-family: "Roboto";
  font-weight: 900;
  font-size: 23px;
  max-width: 550px;
`;

export const BtVoltar = styled.div`
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  background-color: #043c54;
  color: #ffffff;
  padding: 8px 20px;
  margin: 0px 10px;
  border-radius: 6px;
  width: 100px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #3fb6fc;
  }
  img {
    max-width: 15px;
    margin-right: 10px;
  }
`;

export const BtVoltar2 = styled.div`
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  background-color: #043c54;
  color: #ffffff;
  padding: 8px 20px;
  border-radius: 6px;
  width: 165px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #3fb6fc;
  }
  img {
    max-width: 15px;
    margin-right: 10px;
  }
`;

export const BtVoltarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 15px 320px 10px 320px;
  align-items: center;
`;

export const BtSair = styled.div`
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  background-color: #043c54;
  color: #ffffff;
  padding: 8px 20px;
  margin: 0px 10px;
  border-radius: 6px;
  width: 100px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #3fb6fc;
  }
  img {
    max-width: 15px;
    margin-right: 5px;
  }
  div {
    margin-left: 5px;
  }
`;

export const TextoDescNews = styled.div`
  font-family: "Roboto";
  font-size: 16px;
  color: #000000;
  margin: 0px auto 20px auto;
  border-radius: 6px;
  text-align: justify;
  max-width: 550px;
`;

export const BtAvatar = styled.div`
  text-align: center;
  display: inline-block;
  cursor: pointer;
  .BtEditarAvatar {
    font-family: "Roboto";
    font-size: 13px;
    color: #ffffff;
    margin: 5px auto 20px auto;
    text-align: center;
    background-color: #043c54;
    display: inline-block;
    padding: 5px 15px;
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  &:hover .BtEditarAvatar {
    background-color: #3fb6fc;
  }
`;

export const NomePerfil = styled.div`
  text-align: center;
  font-family: "Milky Nice Clean";
  font-size: 25px;
  margin: 5px auto 5px auto;
  color: #043c54;
`;
export const ApelidoPerfil = styled.div`
  text-align: center;
  font-family: "Roboto";
  font-size: 14px;
  margin: 5px auto 5px auto;
  color: #043c54;
`;
export const EmailPerfil = styled.div`
  text-align: center;
  font-family: "Roboto";
  font-size: 18px;
  margin: 5px auto 5px auto;
  color: #043c54;
`;

export const BtGravarAlteracoes = styled.div`
  text-align: center;
  display: inline-block;
  cursor: pointer;
  font-family: "Roboto";
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  margin: 5px auto 20px auto;
  text-align: center;
  background-color: #043c54;
  display: inline-block;
  padding: 5px 15px;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #3fb6fc;
  }
`;

export const NomeTipoAvatar = styled.div`
  font-family: "Milky Nice Clean";
  font-size: 17px;
  text-align: center;
  display: inline-block;
  margin: 15px auto 5px auto;
  color: #043c54;
`;

export const DivListaAvatar = styled.div`
  margin: 5px auto 20px auto;
`;

export const BtOpcaoAvatar = styled.div`
  display: inline-block;
  margin: 0px 4px 10px 4px;
  background-color: 10px;
  border-radius: 6px;
  background-color: ${(props) => props.BgItem};
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    /* opacity: 0.7; */
    /* background-color: #3fb6fc; */
  }
`;

export const TextCarregando = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 15px;
`;

export const BtRankingMoedas = styled.div`
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: #3fb6fc;
    background-color: #dddddd;
    img {
      -webkit-transition: all 0.2s ease-in-out;
      -moz-transition: all 0.2s ease-in-out;
      -o-transition: all 0.2s ease-in-out;
      -ms-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      opacity: 0.5;
    }
  }
  span {
    span {
      margin-right: 4px;
      @media (max-width: 650px) {
        display: none !important;
      }
    }
  }
`;

export const RankingAtualizado = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 15px;
  margin-bottom: 10px;
  span {
    font-weight: 600;
  }
`;

export const ItemRanking = styled.div`
  border-radius: 6px;
  border: 1px solid #043c54;
  padding: 10px 10px 10px 5px;
  display: flex;
  align-items: center;
  text-align: left;
  max-width: 400px;
  margin: 0 auto 10px auto;
  background-color: rgba(255, 255, 255, 0.7);
  color: #043c54;
  font-family: "Roboto";
  font-size: 17px;
  font-weight: 900;
  .ImgAvatar {
    width: 140px;
    margin-right: 10px;
  }
  .DadosUsuario {
    width: 100%;
  }
  .NomeUser {
    font-family: "Milky Nice Clean";
    font-size: 17px;
    margin: 5px auto 0px auto;
    color: #043c54;
    font-weight: normal;
  }
  .PosicaoPontos {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

export const UserLogado = styled(ItemRanking)`
  border: 1px solid #3fb6fc;
  background-color: rgba(227, 227, 227, 0.7);
`;

export const TextoDescPesquisa = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 15px;
  margin-top: -10px;
  margin-bottom: 10px;
  span {
    font-weight: 600;
  }
`;

export const FormPesquisa = styled.form`
  display: block;
  text-align: center;
  margin: 20px auto 0 auto;
  max-width: 550px;
  margin-bottom: 20px;
`;

export const BtIcoBuscar = styled.div`
  background-color: #043c54;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  margin-left: 10px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  img {
    width: 100%;
    max-width: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }
  &:hover {
    background-color: #3fb6fc;
  }
`;

export const CampoFormBusca = styled.div`
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  input,
  select {
    font-family: "Roboto", sans-serif;
    font-size: 20px;

    background-color: #043c54;
    color: #ffffff;
    border: none;
    outline: none;

    padding: 15px 15px;
    width: calc(100% - 92px);
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
    border-radius: 8px;
    border: 1px solid #043c54;
    display: inline-block;
    vertical-align: middle;
    line-height: initial;
  }
  select {
    border: none;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 10px auto;
    text-align: center;
  }
`;

export const DescCampo = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  margin-bottom: 5px;
`;

export const DescCampo2 = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  margin-bottom: 5px;
`;

export const DescCampo3 = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 400;
  text-align: right;
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  margin-bottom: 5px;
`;

export const BotaoEnviarPesquisa = styled.button`
  color: #ffffff;
  font-size: 23px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 100px;
  padding: 10px 45px;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background-color: #043c54;
  letter-spacing: 3px;
  &:hover {
    background-color: #3fb6fa;
    color: #ffffff;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
  }
`;

export const BtAlterarSenha = styled.div`
  color: #ffffff;
  font-size: 15px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 100px;
  padding: 8px 20px;
  margin-top: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background-color: #3fb6fa;
  letter-spacing: 3px;
  display: inline-block;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #043c54;
    color: #ffffff;
  }
  @media (max-width: 650px) {
    display: block;
    margin-left: 0px;
    margin: 10px auto 0 auto;
  }
`;

export const BgModal = styled.div`
  background: rgb(0 0 0 / 50%);
  width: 100%;
  height: 100vh;
  z-index: 99;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const ItemListaBusca = styled.div`
  padding: 10px;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #dddddd;
  }
  .NomeCliente {
    font-family: "Roboto";
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #043c54;
    text-transform: uppercase;
  }
  .CNPJSAP {
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    span {
      width: 40px;
      display: inline-block;
      font-weight: 600;
    }
  }
  .CNPJSAP2 {
    font-family: "Roboto";
    font-size: 0.8rem;
    /* font-weight: 400; */
    color: #000000;
    span {
      width: 40px;
      font-size: 0.9rem;
      display: inline-block;
      font-weight: 600;
    }
  }
  .MarcaCategoriaPeso {
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    span {
      width: 90px;
      display: inline-block;
      font-weight: 600;
    }
  }
`;

export const ClienteProdutoSelecionado = styled.div`
  padding: 10px;
  border-radius: 6px;
  background-color: #dddddd;
  max-width: 385px;
  margin: 0 auto 20px auto;
  text-align: left;
  .NomeCliente {
    font-family: "Roboto";
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #043c54;
    text-transform: uppercase;
  }
  .CNPJSAP {
    font-family: "Roboto";
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    span {
      width: 40px;
      display: inline-block;
      font-weight: 600;
    }
  }
  .MarcaCategoriaPeso {
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    span {
      width: 80px;
      display: inline-block;
      font-weight: 600;
    }
  }
  .BtAlterar {
    color: #ffffff;
    font-family: "Roboto";
    font-size: 13px;
    font-weight: 600;
    background-color: #043c54;
    padding: 5px 10px;
    border-radius: 6px;
    margin-top: 10px;
    cursor: pointer;
    display: inline-block;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    &:hover {
      background-color: #3fb6fa;
    }
  }
`;

export const VideoTreinamento = styled.a`
  padding: 10px;
  border-radius: 6px;
  width: 100%;
  max-width: 40%;
  margin: 0 auto 25px auto;
  text-align: left;
  display: inline-block;
  img {
    border-radius: 6px;
    margin-bottom: 10px;
  }
  &:hover .TituloVideo {
    color: #3fb6fa;
  }
  .TituloVideo {
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    color: #043c54;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
`;

export const LinkMaterial = styled.a`
  padding: 10px;
  text-align: left;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #000000;
  border-top: 1px solid #ddd;
  font-family: "Roboto";
  font-size: 14px;
  svg {
    margin-right: 5px;
    color: #d84315;
  }
  &:hover {
    color: #3fb6fa;
  }
`;

export const NomeCategoriaMaterial = styled.div`
  font-family: "Roboto";
  font-size: 15px;
  text-align: left;
  font-weight: 600;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #043c54;
  div {
    margin-left: 5px;
  }
`;

export const DivAcordeon = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
`;
export const DivAcordeon2 = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 400px;
`;

export const ListaFiltroMes = styled.div`
  display: block;
  margin-bottom: 10px;
`;

export const BtFiltroMes = styled.div`
  display: inline-block;
  vertical-align: middle;
  color: #ffffff;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 700;
  background-color: #043c54;
  padding: 5px 10px;
  margin: 0px 5px;
  border-radius: 6px;
  user-select: none;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  span {
    font-weight: 300;
  }
  &:hover {
    background-color: #3fb6fa;
  }
`;

export const BtFiltroMesAtivo = styled(BtFiltroMes)`
  background-color: #3fb6fa;
  cursor: default;
`;

export const DivQtdPesquisaTotal = styled.div`
  border: 1px solid #dddddd;
  display: inline-block;
  padding: 10px 20px 10px 20px;
  border-radius: 6px;
  margin-bottom: 10px;
  div {
    font-family: "Roboto";
    font-size: 25px;
    font-weight: 900;
  }
`;

export const QntPesquisasTipo = styled.div`
  background-color: #dddddd;
  display: inline-block;
  padding: 10px 20px 10px 20px;
  border-radius: 6px;
  margin: 0px 5px;
  width: 100%;
  max-width: 150px;
  div {
    font-family: "Roboto";
    font-size: 25px;
    font-weight: 900;
  }
`;

export const DivQntPesquisasTipo = styled.div`
  display: flex;
  justify-content: center;
`;

// textAlign: 'center',
// fontFamily: 'Roboto-Regular',
// fontSize:RFValue(16),
// marginTop: 25,
// marginBottom: 10,

export const QntPesquisasDiarias = styled.div`
  font-family: "Roboto";
  font-size: 20px;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
`;

export const QntClientesRespondidos = styled.div`
  font-family: "Roboto";
  font-size: 20px;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
  div {
    font-size: 13px;
    font-weight: 300;
  }
`;

export const ViewGraficoRespondidos = styled.div`
  display: flex;
  justify-content: center;
`;
export const DivTabelaRelatorio = styled.div`
  max-width: 402px;
  margin: 0 auto;
  /* height: 400px; */
`;
export const GraficoRespondido = styled.div`
  width: 140px;
  height: 140px;
  margin: 0px 15px 60px 15px;
  .TipoGrafico {
    margin-top: 10px;
  }
`;
export const DataExtrato = styled.div``;
export const ListaExtrato = styled.div`
  background-color: #e5e5e5;
  padding: 5px 20px;
`;
export const ItemListaExtrato = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dddddd;
  padding: 8px 0px;
  font-family: "Roboto";
  font-size: 14px;
  &:last-child {
    border-bottom: none;
  }
`;
export const DivFilePesquisa = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: center;
  align-items: center;
  border-bottom: 1px solid #dddddd;
  padding: 15px 0px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  div div {
    font-size: 13px;
    font-weight: 300;
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const CaminhoPesquisas = styled.div`
  color: #043c54;
  background-image: url(${BgCaminhoPesquisas});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  padding: 20px;
  width: calc(80% - 40px);
  max-width: 450px;
  height: 85%;
  max-height: 1920px;
  border-radius: 8px;
  -webkit-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  .TituloEvento {
    font-family: "Milky Nice Clean";
    color: #043c54;
    font-size: 20px;
    margin-bottom: 15px;
    text-align: left;
  }
  .TextoEvento {
    height: calc(100% - 50px);
    padding-right: 15px;
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .ListaClientes {
    height: calc(100% - 90px);
    padding-right: 15px;
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .BtFecharModal {
    /* float: left; */
    color: #ffffff;
    font-family: "Roboto";
    font-weight: 600;
    background-color: #043c54;
    padding: 5px 10px;
    border-radius: 6px;
    cursor: pointer;
    position: absolute;
    bottom: 15px;
    right: 20px;
    &:hover {
      background-color: #3fb6fa;
    }
  }
`;

export const ModalAlterarSenha = styled.div`
  color: #043c54;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  padding: 20px;
  width: calc(80% - 40px);
  max-width: 350px;
  height: 85%;
  max-height: 300px;
  border-radius: 8px;
  -webkit-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  .TituloEvento {
    font-family: "Milky Nice Clean";
    color: #043c54;
    font-size: 20px;
    margin-bottom: 15px;
    text-align: left;
  }
  .TextoEvento {
    height: calc(100% - 50px);
    /* padding-right: 15px; */
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .ListaClientes {
    height: calc(100% - 90px);
    padding-right: 15px;
    overflow: auto;
    color: #000000;
    line-height: 20px;
    font-family: "Roboto";
    font-size: 16px;
  }
  .BtFecharModal {
    /* float: left; */
    color: #ffffff;
    font-family: "Roboto";
    font-weight: 600;
    background-color: #043c54;
    padding: 5px 10px;
    border-radius: 6px;
    cursor: pointer;
    position: absolute;
    bottom: 15px;
    right: 20px;
    &:hover {
      background-color: #3fb6fa;
    }
  }
  .BtEnviaAlterarSenha {
    border: none;
    color: #ffffff;
    font-family: "Roboto";
    font-size: 15px;
    font-weight: 600;
    background-color: #3fb6fa;
    padding: 8px 15px;
    border-radius: 6px;
    cursor: pointer;
    outline: none;
    display: block;
    &:hover {
      background-color: #043c54;
    }
  }
`;

export const MetaDiaria = styled.div`
  color: #ffffff;
  background-color: #043c54;
  position: absolute;
  font-family: "Milky Nice Clean";
  margin-bottom: 15px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 6px;
  div {
    text-align: right;
    font-size: 14px;
    line-height: 14px;
    &:last-child {
      font-size: 33px;
      line-height: 33px;
      margin-left: 8px;
    }
  }
`;

export const BtNovaPesquisa = styled.div`
  color: #ffffff;
  background-color: #043c54;
  position: absolute;
  font-family: "Roboto";
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: left;
  padding: 8px 10px;
  border-radius: 6px;
  bottom: 35px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  user-select: none;
  &:hover {
    background-color: #3fb6fa;
  }
`;

export const QntPesquisasRealizadas = styled.div`
  color: #043c54;
  background-color: #ffffff;
  position: absolute;
  font-family: "Roboto";
  font-size: 14px;
  line-height: 15px;
  margin-bottom: 15px;
  text-align: left;
  padding: 5px 10px;
  border-radius: 6px;
  bottom: 0px;
  left: 20px;
`;

export const BtPassos = styled.div`
  position: absolute;
  top: ${(props) => props.Top}%;
  left: ${(props) => props.Left}%;
  background-image: url(${(props) => props.BgPasso});
  background-size: cover;
  width: 40px;
  height: 40.86px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
`;

export const DivSaldo = styled.div`
  /*
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#043c54',
        padding: 5,
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: 6,
        marginBottom: 10
    */

  background-color: #043c54;
  padding: 10px 20px;
  border-radius: 6px;
  max-width: 450px;
  margin: 0 auto 10px auto;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  font-family: "Roboto";
  font-size: 14px;

  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;

  span {
    font-weight: 600;
  }
  &:hover {
    opacity: 0.9;
  }
`;

export const ValorLojinha = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e4e5e4;
  padding: 5px 10px;
  border-radius: 6px;
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  color: #043c54;
  position: absolute;
  bottom: -5px;
  right: -2px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  img {
    max-width: 20px;
    margin-right: 6px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

export const BtCompraItem = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

export const ItemClubeOfertas = styled.div`
  width: 48%;
  display: inline-block;
  vertical-align: top;
  background-color: #dddddd;
  border: 1px solid #dddddd;
  margin: 0px 4px 20px 4px;
  border-radius: 6px;
  position: relative;
`;

export const ImgBannerClubeOfertas = styled.img`
  width: 100%;
  margin-bottom: 1px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;
export const ImgLogoClubeOfertas = styled.div`
  width: 100%;
  margin-bottom: 10px;
  background-color: #ffffff;
  text-align: center;
  img {
    width: 50%;
  }
`;

export const TextoCupom = styled.div`
  padding: 10px 10px 30px 10px;
  text-align: left;
  .NomeCupom {
    font-family: "Roboto";
    font-weight: 600;
    font-size: 15px;
    color: #043c54;
    text-transform: uppercase;
    div {
      color: #3fb6fa;
    }
  }
  .DescCupom {
    font-family: "Roboto";
    margin-top: 5px;
    color: #043c54;
    font-size: 14px;
  }
`;

export const ValorLojinhaCupom = styled.div`
  display: flex;
  align-items: center;
  background-color: #e4e5e4;
  padding: 5px 10px;
  border-radius: 6px;
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  color: #043c54;
  position: absolute;
  bottom: -10px;
  left: -5px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  img {
    max-width: 20px;
    margin-right: 6px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

export const BtAcessarCupom = styled.a`
  display: flex;
  align-items: center;
  background-color: #3fb6fa;
  padding: 5px 10px;
  border-radius: 6px;
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  position: absolute;
  bottom: -10px;
  left: -5px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  user-select: none;
  img {
    max-width: 20px;
    margin-right: 6px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

export const TextoExplicacaoCasinha = styled.div`
  text-align: left;
  font-family: "Roboto";
  font-size: 12px;
  color: #043c54;
  margin: 30px auto 0 auto;
  width: 100%;
  max-width: 500px;
`;

export const LinhaResultadoFornada = styled.div`
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #dddddd;
  padding: 10px 10px 10px 10px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 0 auto;
  div {
    width: 100%;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
      color: #043c54;
      font-weight: 600;
    }
  }
`;

export const DataAtualizacaoFornada = styled.div`
  padding: 10px 10px 10px 10px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 0 auto;
  text-align: left;
  font-family: "Roboto";
  font-size: 14px;
  color: #043c54;
`;

export const BtVerRelatorioCompleto = styled.div`
  background-color: #3fb6fc;
  padding: 10px 8px 10px 8px;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: #ffffff;
  text-transform: uppercase;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  max-width: 500px;
  margin: 20px auto 0 auto;
  cursor: pointer;
  align-items: center;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #043c54;
  }
  div {
    margin-left: 5px;
  }
`;

export const BtNovoAtendimento = styled(BtVerRelatorioCompleto)`
  max-width: 460px;
  margin: 10px auto;
`;

export const BtFiltrar = styled.div`
  color: #ffffff;
  font-family: "Roboto";
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  text-transform: uppercase;
  outline: none;
  border: none;
  background-color: #3fb6fa;
  margin-left: 10px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  user-select: none;
  &:hover {
    background-color: #043c54;
  }
`;

export const BtCheckBox = styled.div`
  cursor: default;
  text-align: left;
  input {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    cursor: pointer;
    user-select: none;
  }
  span {
    width: 100%;
    vertical-align: middle;
    user-select: none;
  }
`;

export const BtFecharAtendimento = styled.div`
  color: #ffffff;
  font-family: "Roboto";
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  text-transform: uppercase;
  outline: none;
  border: none;
  background-color: #3fb6fa;
  margin-bottom: 10px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  user-select: none;
  text-align: center;
  display: inline-block;
  &:hover {
    background-color: #043c54;
  }
`;

export const EndLinha = styled.div`
  display: flex;
  width: 100%;
  max-width: 385px;
  margin: 0 auto;
  div {
    &:last-child {
      margin-left: 10px;
    }
  }
`;

export const EndLinha01 = styled(EndLinha)`
  div {
    &:first-child {
      width: 70%;
    }
    &:last-child {
      width: 30%;
    }
  }
`;

export const EndLinha02 = styled(EndLinha)`
  div {
    &:first-child {
      width: 40%;
    }
    &:last-child {
      width: 60%;
    }
  }
`;

export const EndLinha03 = styled(EndLinha)`
  div {
    &:first-child {
      width: 55%;
    }
    &:last-child {
      width: 45%;
    }
  }
`;

export const EndLinha04 = styled(EndLinha)`
  div {
    &:first-child {
      width: 50%;
    }
    &:last-child {
      width: 50%;
    }
  }

  small {
    text-align: left;
  }
`;

export const RespostaForm = styled.div`
  color: #000000;
  font-family: "Roboto";
  font-size: 13px;
  padding: 10px 10px;
  border-radius: 6px;
  outline: none;
  border: none;
  background-color: #ffffff;
  border: 1px solid #dddddd;
  margin-bottom: 10px;
  text-align: left;
  span {
    margin-bottom: 10px;
    display: block;
    div {
      color: #043c54;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;

export const ItemListaAtendimentos = styled.div`
  margin-bottom: 30px;
  background-color: #e8e8e8;
  border: 1px solid #dddddd;
  border-radius: 6px;
  max-width: 470px;
  margin: 0 auto 10px auto;
  color: #ffffff;
  font-family: "Roboto";
  padding: 10px 10px 0px 10px;
  text-align: left;
`;

export const SolicitanteCliente = styled.div`
  margin: 0 auto 10px auto;
  color: #000000;
  font-family: "Roboto";
  font-size: 13px;
  div {
    text-transform: uppercase;
    font-size: 15px;
    font-weight: 600;
    color: #043c54;
  }
`;

export const TipoAtendimento = styled.div`
  margin: 0 auto 10px auto;
  color: #000000;
  font-family: "Roboto";
  font-size: 13px;
  div {
    font-size: 14px;
    color: #043c54;
  }
`;

export const ColunaTextoGBTechConnect = styled.div`
  width: calc(100% - 100px);
  max-width: 1160px;
  margin: 0 auto;
  position: relative;
  @media (max-width: 800px) {
    width: calc(100% - 40px);
  }
`;

export const ColunaZoom = styled.div`
  width: calc(100% - 100px);
  max-width: 1570px;
  margin: 0 auto;
  @media (max-width: 800px) {
    width: calc(100% - 40px);
  }
`;

export const ColunaComoFunciona = styled.div`
  width: calc(100% - 100px);
  max-width: 1300px;
  margin: 0 auto;
  @media (max-width: 800px) {
    width: calc(100% - 40px);
  }
`;

export const TextoBemVindo = styled.h1`
  color: #0dd6b2;
  font-size: 30px;
  text-align: center;
  max-width: 930px;
  margin: 0 auto 40px auto;
  @media (max-width: 800px) {
    font-size: 25px;
  }
  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

export const TextoInscrevase = styled.div`
  color: #e0e0e0;
  font-size: 23px;
  text-align: center;
  max-width: 880px;
  margin: 0 auto 40px auto;
  span {
    color: #0dd6b2;
  }
  h1 {
    font-size: 30px;
    color: #0dd6b2;
  }
  @media (max-width: 800px) {
    font-size: 20px;
    h1 {
      font-size: 25px;
    }
  }
  @media (max-width: 600px) {
    font-size: 18px;
    h1 {
      font-size: 20px;
    }
  }
`;

export const TextoEmailInvalido = styled.div`
  font-family: "Montserrat", sans-serif;
  color: #acacac;
  font-size: 20px;
  text-align: center;
  margin-top: -70px;
  a {
    color: #ffffff;
    font-weight: bold;
    &:hover {
      color: #cc2395;
    }
  }
  @media (max-width: 500px) {
    font-size: 18px;
  }
  @media (max-width: 450px) {
    font-size: 16px;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

export const SelecioneUmaOpcao = styled.div`
  font-family: "Montserrat", sans-serif;
  color: #acacac;
  font-size: 20px;
  text-align: center;
  @media (max-width: 500px) {
    font-size: 18px;
  }
  @media (max-width: 450px) {
    font-size: 16px;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

export const TituloRelatorioTrade = styled.div`
  font-size: 20px;
  text-align: left;
  margin-left: 0px;
  div {
    &:first-child {
      margin-left: 0px;
      font-size: 16px;
      font-weight: normal;
      color: #000000;
    }
    &:last-child {
      margin-left: 0px;
      font-size: 12px;
      color: #22569e;
    }
  }
`;

export const AreaHome = styled.div`
  width: 40%;
  padding: 100px 0 0 0;
  margin: 0 auto;
`;

export const StyledForm = styled.form`
  padding: 25px;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  overflow: auto;
`;

export const TituloMensagem = styled.h2`
  margin: 20px 0 10px 0;
  font-size: 32px;
  font-family: "Milky Nice Clean";
`;
